/**
 * View for filling in a price
 * Consists of an input field and a preview of the price,
 * formatted according to a given currency and locale
 **/

import BaseView from '../../base-view';
import i18n from '../../utils/i18n';
import Model from './model';

export default BaseView.extend({

	events: {
		'focus .js-price-input': 'setPrice',
		'input .js-price-input': 'updatePrice',
		'blur .js-price-input': 'setFormattedPrice'
	},

	initialize: function() {
		// reference to elements
		this.priceInput = this.query('.js-price-input');
		this.priceUnformatted = this.query('.js-price-value');

		// reference to model
		this.model = this.model || new Model();

		// model listener
		this.listenTo(this.model, 'change:currency', this.setFormattedPrice);
		this.listenTo(this.model, 'change:price', this.setUnformattedPrice);

		if (this.priceUnformatted.value && parseFloat(this.priceUnformatted.value) !== 0) {
			this.model.set('price', this.priceUnformatted.value);
		}
		// prefill input
		this.setFormattedPrice();
	},

	/**
	 * Fill input with unformatted price
	 **/
	setPrice: function() {
		var price = this.model.get('price');
		this.priceInput.value = price;
	},

	/**
	 * Fill input with formatted price
	 **/
	setFormattedPrice: function() {
		var price = this.model.get('price') || 0,
			priceFormatted = i18n.formatNumberAsCurrency(
				parseFloat(price),
				this.model.get('currency'),
				4
			);

		this.priceInput.value = priceFormatted;
	},

	/**
	 * Set the unformatted price
	 **/
	setUnformattedPrice: function(model, price) {
		this.priceUnformatted.value = price;
	},

	/**
	 * Update price property in model
	 **/
	updatePrice: function() {
		this.model.set('price', this.priceInput.value);
	}
});
